<template>
  <div class="formBtn">
    <b-button id="submitBtn" :disabled="disabled" @click="onClick"
      ><slot>{{ $t(localeConsts.submitButton) }} </slot></b-button
    >
  </div>
</template>

<script>
export default {
  name: 'SubmitButton',
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      localeConsts: {
        submitButton: 'STATUSREPORTS.SUBMIT'
      }
    }
  },
  methods: {
    onClick() {
      this.$emit('clickEvent')
    }
  }
}
</script>
